<template>
<div class="chapter">
<div class="inner_page">
<p class="ser" id="pz20-1">
<img alt="images/img-20-1.jpg" class="imgpub" id="z20-1" src="images/img-20-1.jpg"/></p>
<p class="ct" id="pz20-2">
<a href="#/contents#ch2">Chapter 2</a></p>
<p class="ct1"><a href="#/contents#ch2">
					So Many Questions</a></p>
<p class="txc1" id="ASrf">
					2002 11.2 Summer </p>
<p class="tx" id="pz20-3">
					On a sunny, spring day in May, a long time ago, I began an important journey to adulthood.
					Holding hands, two abreast, my third grade classmates and I marched like a parade
					down the Harlan Street sidewalk from old North School to the Lydia Brunn Woods Library.
					Little did I know this field trip would change my life. </p>
<p class="tx" id="pz20-4">
					Ms. Heiser, our teacher, seemed a little more serious than she usually was. Her eyes
					glistened behind her dark-rimmed glasses. In her polite way, she was serious, and
					I sensed whatever was about to happen would be important, although, I had no idea
					why. </p>
<p class="tx" id="pz20-5">
					We giggled and talked to each other about this great, new adventure, as we proceeded
					down the street. </p>
<p class="tx" id="pz20-6">
					“What’s a library for?” I said. </p>
<p class="tx" id="pz20-7">
					“To get books,” replied Carole. </p>
<p class="tx" id="pz20-8">
					“I know that, but why do people have to have a whole building for books?” </p>
<p class="tx" id="pz20-9">
					“Adults read a lot,” Bill answered. </p>
<p class="tx" id="pz20-10">
					“But why do they read so much?” I wanted to know. </p>
<p class="tx" id="pz20-11">
					“To get answers,” Jimmy smiled. </p>
<p class="tx" id="pz20-12">
					“Well, why do they have to have so many questions?” I asked. </p>
<p class="tx" id="pz20-13">
					“Because young men like you grow up some day, and they don’t change much,” Ms. Heiser
					smiled. “It is good to ask questions and want to know the answers. Smart people go
					to libraries, and good towns provide good libraries for their citizens. You are lucky
					to live in this town, because we have a fine library that you will be able to use
					all your life.” </p>
<p class="tx" id="pz20-14">
					I did not talk much more on our walk. What Ms. Heiser said kept <span id="z21-1">me thinking for the
					rest of the trip. Just as we began to sweat from the exertion, our group arrived
					at the front door of the library. </span></p>
<p class="tx" id="pz21-2">
					We received a warning about being quiet when we entered, minding our manners, and
					not disturbing the adults. If we were good, we would have treats and orange juice,
					and then we could have twenty minutes to look for a book of our own to check out
					and take back to school. </p>
<p class="tx" id="pz21-3">
					I knew about St. Peter, the Pearly Gates, and imagined going to Heaven must be something
					like entering the library. We left the heat of the day behind and entered into cooler
					air that was circulated by one fan. The librarians stood at attention, as we filed
					passed them. Only one smiled. I felt out of place but was eager to know what went
					on here, and I was curious if I would enjoy the experience. </p>
<p class="tx" id="pz21-4">
					My mother and grandmother read all the time. Some days, they could not pull themselves
					away from their books, and I wondered if my other relatives read this much, too.
					I was afraid of becoming just like them, since we were related. My baseball game
					might suffer, if I became addicted to books like they were. I could not let that
					happen. </p>
<p class="tx" id="pz21-5">
					I had a chip on my shoulder and an attitude. Passing through the library door, I
					remember thinking, “Well, this better be good. Show me any book that will make me
					want to read rather than play center field for my baseball team.” </p>
<p class="tx" id="pz21-6">
					We received a brief tour of the first floor area reserved for adults and students
					in junior high and high school. Then the guide said, “You children will find your
					treats and your books upstairs. When you go to the second floor, walk quietly, not
					like elephants.” </p>
<p class="tx" id="pz21-7">
					My schoolmates heard the word “treats” and headed upstairs at once. They did not
					remember the word “elephants.” We grouped together at the top of the stairs, drank
					our juice, and ate our cookies. I finished eating as quickly as I could, because
					I wanted to see the books. Some took their time eating, but I asked if I could start
					looking right away. The librarian smiled and let me start early. </p>
<p class="tx" id="pz21-8">
					As I went down the hall, I could smell dust and the old books on the shelves. The
					rooms upstairs seemed dark and partially lit. I learned later that was one technique
					to keep patrons cool in the non-air-conditioned building. I went into one small room
					and then farther into a large room with bookcases from the floor to the ceiling.
					My jaw dropped open. </p>
<p class="tx" id="pz21-9">
					“What kids are going to read all of these books?” </p>
<p class="tx" id="pz21-10">
					As if she could read my mind, the librarian who helped prepare <span id="z22-1">the treats for us,
					said loudly, “What book are you looking for, Mr. Martin?” </span></p>
<p class="tx" id="pz22-3">
					She scared me, and I wondered how she knew my name. I impulsively belted back, “Baseball.
					I want to read about baseball.” </p>
<p class="tx" id="pz22-5">
					Without any hesitation, she pulled me over to the far wall, took three books off
					the shelf, and said, “Here. You can sit on the floor and look at these, if you like.”
					</p>
<p class="tx" id="pz22-8">
					In thirty seconds, she gave me three books, got me off my feet, saw that I was looking
					at them, and left to help someone else. I read a short chapter and liked it. I looked
					at the wall and read some of the other titles. The ones lower on the wall, the ones
					closest to me, were for children my age. The topics became more difficult, as my
					eyes rose higher and higher. What children would read the ones on the top shelves?
					</p>
<p class="tx" id="pz22-9">
					I sat down, content to be cool, enjoying a book about something I understood, baseball,
					and thinking, “I could come back here, anytime. I could walk from home to the library.
					I would just cut across the park and walk up the street a few blocks. I wonder how
					long it would take me to read these three books. Would I return next week or the
					week after?” </p>
<p class="tx" id="pz22-10">
					Ms. Heiser announced, “It is time to return to school. Let’s go downstairs and check
					out any books you want to take with you. Do not take any more than you want to carry
					all the way back to school.” </p>
<p class="tx" id="pz22-13">
					I checked out all three of mine. It was a struggle to carry them back to school,
					but I didn’t mind. I felt a little older, as we walked down the street. My arms hurt
					a little when we returned to our classroom, because I was not used to carrying books
					that far. </p>
<p class="tx" id="pz22-14">
					I did not mind. I knew the road to adulthood would require more effort than carrying
					these books, and the trip to maturity would be a lot longer and harder than my trip
					to the library was that day. </p>
<p class="tx" id="pz22-15">
					Our class was a lot quieter after returning to our school than it was going to the
					library. Sally asked me what I thought of the experience. </p>
<p class="tx" id="pz22-16">
					“Now, I know where my mother goes all the time,” I said. “I think the library is
					neat. Did you see all those books downstairs when we took the tour? I want to go
					back and look at the history books, encyclopedias, that huge dictionary, and those
					magazines. What was that card catalogue, anyway?” </p>
<p class="tx" id="pz22-17">
					“You think too much,” Della said. </p>
<p class="tx" id="pz22-18">
					“Do you suppose Heaven is like a colossal library?” I asked. “Do <span id="z23-1">you think God sits
					around reading all day? Is that why he knows so much? Is that where Creation came
					from?” </span></p>
<p class="tx" id="pz23-2">
					“What?” Janice wondered. </p>
<p class="tx" id="pz23-3">
					“Do you think people could find answers to all of their questions in a library? Wouldn’t
					that be something? Did you see all those big books? The middle sized ones? The small
					ones? Would there be more information and better answers in the larger books than
					the smaller ones? If so, why don’t people just read the big ones? Larger books, more
					answers, smarter people? Why is the newspaper right across the street from the library?
					Do they work together? Wouldn’t ‘Hope’ be a great name for a librarian?” </p>
<p class="ser1">
<img alt="images/img-23-1.jpg" class="imgpub" id="z23-4" src="images/img-23-1.jpg"/></p>
<p class="fcap" id="pz23-5">
<i>Cute Baby Goslings</i> · <b>James Phelps</b> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter02.vue?3f488fbc